import { VEHICLE_SORT_OPTIONS, type VehicleSortKey, type VehicleView } from './vehicleListing.constants';
import { VehicleSelect } from './VehicleSelect';
import { VehicleViewSwitch } from './VehicleViewSwitch';

type VehicleListingToolbarProps = {
    total: number;
    sort: VehicleSortKey;
    onSort: (sort: VehicleSortKey) => void;
    view: VehicleView;
    onView: (view: VehicleView) => void;
};

/** Hit count, sort and — from md, beside the filter column — the view switch. */
export function VehicleListingToolbar({ total, sort, onSort, view, onView }: VehicleListingToolbarProps) {
    return (
        <div className="vehicle-toolbar">
            <p className="vehicle-toolbar__count text-md">
                <b className="label-lg font-bold">{total}</b> {total === 1 ? 'Fahrzeug' : 'Fahrzeuge'}
            </p>

            <div className="vehicle-toolbar__tools">
                <label className="vehicle-toolbar__sort">
                    <span className="vehicle-toolbar__sort-word label-sm">Sortieren</span>
                    <VehicleSelect
                        ariaLabel="Sortieren"
                        value={sort}
                        options={VEHICLE_SORT_OPTIONS}
                        onChange={(value) => onSort(value as VehicleSortKey)}
                    />
                </label>

                <VehicleViewSwitch view={view} onChange={onView} className="hidden md:flex" />
            </div>
        </div>
    );
}
